<template>
  <el-form
      label-position="top"
      ref="form"
      :model="form"
      :rules="rules"
      class="form"
      size="mini">
    <el-table
        size="mini"
        border
        :data="form.items"
        style="width: 100%; margin-top: 10px;">
      <el-table-column
          label="Tran ID#"
          width="80"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="'items.' + scope.$index + '.tranId'">
            <el-input v-model="scope.row.tranId"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Payment Method"
          width="120"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="'items.' + scope.$index + '.paymentMethodId'">
            <el-input v-model="scope.row.paymentMethodId"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Deposit Account"
          width="120"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="'items.' + scope.$index + '.depositAccountId'">
            <el-input v-model="scope.row.depositAccountId"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Amount Received"
          width="150"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="'items.' + scope.$index + '.amountReceived'">
            <el-input v-model="scope.row.amountReceived"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Balance to Received"
          width="160"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="'items.' + scope.$index + '.balanceToReceived'">
            <el-input v-model="scope.row.balanceToReceived"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Balance to Received"
          width="160"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="'items.' + scope.$index + '.chequeRef'">
            <el-input placeholder="Cheque Vaucher/Ref #" v-model="scope.row.chequeRef">
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Date of Cheque"
          width="120"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="'items.' + scope.$index + '.dateOfCheque'" >
            <el-date-picker
                v-model="scope.row.dateOfCheque"
                :clearable='false'
                format="d MMM yy"
                value-format="MM-dd-yyyy"
                type="date"
                placeholder="Select Date">
            </el-date-picker>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Cheque Issue Date"
          width="140"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="'items.' + scope.$index + '.chequeIssueDate'" >
            <el-date-picker
                v-model="scope.row.chequeIssueDate"
                :clearable='false'
                format="d MMM yy"
                value-format="MM-dd-yyyy"
                type="date"
                placeholder="Select Date">
            </el-date-picker>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Cheque Issued By"
          width="140"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="'items.' + scope.$index + '.chequeIssuedBy'">
            <el-input v-model="scope.row.chequeIssuedBy"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
          label="Payment Status"
          width="120"
          align="center">
        <template slot-scope="scope">
          <el-form-item :prop="'items.' + scope.$index + '.paymentStatus'">
            <el-input v-model="scope.row.paymentStatus"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>
    <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
      <el-button type="primary" size="mini" @click="add">Add New Post Payment Line</el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "ReceivePostDatedChequesMethod",
  data() {
    return {
      form: {
        items: [{
          tranId: null,
          paymentMethodId: null,
          depositAccountId: null,
          amountReceived: null,
          balanceToReceived: null,
          chequeRef: null,
          dateOfCheque: null,
          chequeIssueDate: null,
          chequeIssuedBy: null,
          paymentStatus: null
        }]
      },
      rules: {

      }
    }
  },
  methods: {
    add() {
      this.form.items.push({
        tranId: null,
        paymentMethodId: null,
        depositAccountId: null,
        amountReceived: null,
        balanceToReceived: null,
        chequeRef: null,
        dateOfCheque: null,
        chequeIssueDate: null,
        chequeIssuedBy: null,
        paymentStatus: null
      })
    }
  }
}
</script>

<style scoped>

</style>